import React, { useState } from 'react';
import { Divider } from 'antd';
import { ClassPageToolbar } from './ClassPageToolbar';
import { ClassList } from './ClassList';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
export const ClassPage = (props) => {
    const [] = useState([]);
    const [] = useState(true);
    let { event_id, competition_id } = props;
    const [, , , , , canEdit] = useCompetition(competition_id);
    return (React.createElement(React.Fragment, null,
        React.createElement(ClassPageToolbar, { competition_id: props.competition_id, disabled: !canEdit }),
        React.createElement(Divider, null),
        React.createElement(ClassList, { event_id: event_id, competition_id: competition_id, disabled: !canEdit })));
};
